export enum SuggestionCategory {
    Category = 'Category',
    Translation = 'Translation',
    Label = 'Label',
}
